import React from "react";

const Intro = () => {
    return (
        <>
            <div className="container-fluid" id="third-section">
                <section className="container text-center py-4">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12  py-4">
                            <h4 className="py-2">Boost your links today</h4>
                            <button type="submit" className="btn btn-custom mx-auto">
                                Get Started
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Intro;
